// src/initTracking.ts
import {
  initializeEventTracking,
  PixelAdapter,
  GoogleAnalyticsAdapter,
  KpAdapter,
} from "@/events";

export async function initTracking() {
  const pixelAdapter = new PixelAdapter({
    pixelId: process.env.NEXT_PUBLIC_PIXEL_ID || '',
  });

  const gaAdapter = new GoogleAnalyticsAdapter({
    measurementId: process.env.NEXT_PUBLIC_GA_ID || '',
  });

  // Initialize the KP adapter
  const kpAdapter = new KpAdapter();

  await initializeEventTracking([pixelAdapter, gaAdapter, kpAdapter]);
}